import React, { useState } from 'react'
import { Button, Popover, Tooltip } from 'antd'
import { FolderSymlink } from 'lucide-react'
import { GroupSelectorPopoverContent } from './GroupSelectorPopoverContent'

interface Props {
  groupId: string
  currentGroupId?: string
}

export const GroupSelectionButton: React.FC<Props> = ({
  groupId,
  currentGroupId
}) => {
  const [open, setOpen] = useState(false)

  return (
    <Popover
      content={
        <GroupSelectorPopoverContent
          entityId={groupId}
          parentGroupId={currentGroupId}
          entity="group"
          onClose={() => setOpen(false)}
        />
      }
      destroyTooltipOnHide
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottom"
    >
      <Tooltip title="Move Group">
        <Button
          type="text"
          icon={<FolderSymlink className="h-4 w-4" />}
          className="hover:text-primary"
        />
      </Tooltip>
    </Popover>
  )
}
